<template>
  <component :is="tag">
    <template v-for="(segment, index) in segments" :key="index">
      <strong v-if="segment.type === 'strong'">{{ segment.text }}</strong>
      <em v-else-if="segment.type === 'em'">{{ segment.text }}</em>
      <a v-else-if="segment.type === 'link'" :href="segment.href" target="_blank" rel="noopener noreferrer">
        {{ segment.text }}
      </a>
      <template v-else>{{ segment.text }}</template>
    </template>
  </component>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { parseMarkdown } from "@/shared-helpers/markdown.helper";

/**
 * Safely renders the small markdown subset (`<strong>` and `[label](url)`)
 * supported by payment copy. It parses the string into typed segments and
 * renders real elements through interpolation, so no raw HTML is ever injected
 * (a drop-in, XSS-safe replacement for `v-html`).
 */
export default defineComponent({
  name: "MarkdownRenderer",
  props: {
    // Raw string that may contain `<strong>…</strong>` and/or `[label](url)`.
    content: {
      type: String,
      default: "",
    },
    // Wrapper element to render the segments into (e.g. "p", "span").
    tag: {
      type: String,
      default: "span",
    },
  },
  setup(props) {
    const segments = computed(() => parseMarkdown(props.content));
    return { segments };
  },
});
</script>
